import { Fragment } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { Divider } from '@ui-kitten/components';

import ProfileForm from '../../Components/ProfileForm';
import { isUserDetailsIncomplete } from '../../Helper';
import { checkout } from '../../RTK/defaultValues';
import { userSelector } from '../../RTK/user/selectors';
import themeStyle from '../../Theme/styles';

import useCheckoutHandler from './controller/useCheckoutHandler';

const UserDetailsRow = () => {
  const { formUserDetails, onUpdateCheckoutDetails } = useCheckoutHandler();
  const user = useSelector(userSelector);

  const _onChange = (name, value) => {
    onUpdateCheckoutDetails(checkout.keys.USER_DETAILS, {
      ...formUserDetails,
      [name]: value,
    });
  };

  if (!isUserDetailsIncomplete(user)) return null;

  return (
    // only spacing top medium, since last input has bottom spacing medium
    <Fragment>
      <View style={themeStyle.spacingTopMedium}>
        <ProfileForm values={formUserDetails} onChange={_onChange} />
      </View>
      <Divider style={themeStyle.divider} />
    </Fragment>
  );
};

export default UserDetailsRow;
